import { render, staticRenderFns } from "./AddRelationDialog.vue?vue&type=template&id=3fa7cdde&"
import script from "./AddRelationDialog.vue?vue&type=script&lang=js&"
export * from "./AddRelationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports